export default __webpack_public_path__ + "static/media/Therapist T&Cs - Membership Agreement.fead0cfb.pdf";